export enum PhaseEndResult {
	Success = "Success",
	Failed = "Failed",
}
